<template>
  <component class="icon" :is="iconComponent" />
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
});

const iconComponent = defineAsyncComponent(
  () => import(`../../assets/icons/${props.icon}.svg`),
);
</script>

<style lang="scss">
.icon {
  height: 20px;
  width: 20px;
  vertical-align: middle;
  @include svgColor($black);
}
</style>
